import { render, staticRenderFns } from "./TaxRelation.vue?vue&type=template&id=557c1992"
import script from "./TaxRelation.vue?vue&type=script&lang=js"
export * from "./TaxRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports